// extracted by mini-css-extract-plugin
module.exports = {"CollectionProducts__products":"CollectionProducts_CollectionProducts__products__1rfBH","CollectionProducts__search":"CollectionProducts_CollectionProducts__search__3tFuz"};